import React, { useEffect, useRef, useState } from "react";
import "./PayTab.scss";
import { Avatar, Button, Col, Form, Row, Space, notification } from "antd";
import { InputFields, StepInfo } from "components/common";
import { PayTabConfig } from "./PayTab.config";
import PayDetailTab from "./PayDetailTab/PayDetailTab";
import Icon from "assets/icons";
import { payService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { FIELD_TYPE, TEN_PHONG, tabKeys } from "types/enums";
import {
  setActiveKey,
  setIdPhieuKham,
  setIdReceiptPrint,
} from "redux/reducer/common";
import moment from "moment";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";
import ModalPrint from "./ModalPrint/ModalPrint";
import ModalPrintBH from "./ModalPrintBH/ModalPrintBH";
import Notification from "components/common/notification/notification";
import { setMaBenhNhan, setValueInput } from "redux/reducer/reduxCommon";
import { dispatchCurrentRoom } from "helper/common";
import { catalogService, employeeService } from "api";
import { DataFormField } from "types/models/input-field-type";
import ModalOption from "./ModalOption/ModalOption";
import ModalPrintPTT from "./ModalPrintPTT/ModalPrintPTT";
const { INPUT, SELECT, DATE, AUTO_COMPLETE } = FIELD_TYPE;

type infoDetailsProps = {
  chiTietLoaiKhamChuaBenh: any;
  chiTietTrangThaiBaoHiem: any;
  chiTietTrangThaiThanhToan: any;
  diaChi: string;
  gioiTinh: number;
  hoVaTen: string;
  id: number;
  idKhuKhamChuaBenh: any;
  idLoaiKhamChuaBenh: number;
  idTrangThaiBaoHiem: number;
  idTrangThaiThanhToan: number;
  maBenhNhan: any;
  maKhamBenh: any;
  ngaySinh: string;
  soTheBaoHiemYTe: string;
  tenNhanVienThanhToan: any;
  tenNhanVienTiepNhan: any;
  tienTranBaoHiem: number;
};

const PayTab = () => {
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<infoDetailsProps>();
  const idData = useAppSelector((state) => state.reduxCommon.id);
  const [currentTab, setCurrentTab] = useState(tabKeys.PAYCHILD.PAY_CHILD);
  const dataPayTab = useAppSelector((state) => state.reduxCommon.dataPay);
  const disPath = useAppDispatch();
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const listIdPrint = useAppSelector((state) => state.reduxCommon.listIdCommon);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [isShowModalOption, setIsShowModalOption] = useState(false);
  const [isShowModalPrintBH, setIsShowModalPrintBH] = useState(false);
  const [isShowModalPrintPTT, setIsShowModalPrintPTT] = useState(false);
  const [trangThaiBH, setTrangThaiBH] = useState();
  const [listId, setListId] = useState();
  // const stepInfoRef = useRef<any>();

  const onChangeInput = (event) => {
    // let value = event.target.value;
    disPath(setValueInput(event));
  };

  useEffect(() => {
    if (!idData) {
      disPath(setActiveKey(tabKeys.PAY.LIST_PENDING));
    }
  }, [idData]);

  const fieldsPayTab: DataFormField[] = [
    {
      type: INPUT,
      label: "Số điện thoại",
      name: "soDienThoai",
      disable: true,
    },

    {
      type: INPUT,
      label: "Địa chỉ",
      name: "diaChi",
      disable: true,
    },

    {
      type: DATE,
      label: "Ngày vào viện",
      name: "ngayVaoVien",
      // optionsTime: {format: FORMAT_TIME.dayFull},
      disable: true,
    },
    {
      type: SELECT,
      label: "Loại KCB",
      placeholder: "Chọn",
      name: "idLoaiKhamChuaBenh",
      disable: true,
    },
    {
      type: INPUT,
      label: "Lý do khám",
      name: "lyDoKham",
      disable: true,
    },
    {
      type: INPUT,
      label: "Thân nhân",
      name: "thanNhan",
      disable: true,
    },
    {
      type: AUTO_COMPLETE,
      label: "Tên thu ngân",
      name: "tenNhanVienThanhToan",
      // disable: true
      onChange: onChangeInput,
    },
    {
      type: INPUT,
      name: "phanTramMienGiam",
      label: "TL miễn giảm",
      placeholder: "-",
      // css:  {sm: 24, md: 6, lg: 6 },
      disable: true,
    },
    {
      type: INPUT,
      name: "soTheBaoHiemYTe",
      label: "Số thẻ BHYT",
      placeholder: "-",
      // css:  {sm: 24, md: 6, lg: 6 },
      disable: true,
    },
  ];
  const [field, setField] = useState(fieldsPayTab);

  const gender = () => {
    if (data) {
      if (data.gioiTinh === 0) {
        return "Nam";
      }
      if (data.gioiTinh === 1) {
        return "Nữ";
      }
    } else return "Không có";
  };

  useEffect(() => {
    getListDetail();
    getListLoaiKCB();
  }, [currentPage, idData, callApi]);

  const getListLoaiKCB = async () => {
    try {
      const res = await catalogService.getListLoaiKCB();
      fieldsPayTab.find((e) => e.name == "idLoaiKhamChuaBenh").options =
        await res.map((e) => {
          return { value: e.id, label: e.tenLoaiKCB };
        });
      setField([...fieldsPayTab]);
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy danh sách loại khám chữa bệnh");
      // fields[8].options = [];
    }
  };

  useEffect(() => {
    getListEmployee();
    const nhanVien = form.getFieldValue("tenNhanVienThanhToan");
    if (nhanVien) {
      disPath(setValueInput(nhanVien));
    }
  }, [idData]);

  const getListEmployee = async () => {
    try {
      const response =
        (await employeeService.searchEmployee({
          page: 1,
          limit: 1000,
        })) || [];
      fieldsPayTab.find((e) => e.name == "tenNhanVienThanhToan").options =
        response.items.map((e) => {
          return { value: e.hoTen, label: e.hoTen };
        });
      setField([...fieldsPayTab]);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const getListDetail = async () => {
    try {
      const response = await payService.getPatientById(idData).then((res) => {
        // notification.success({ message: "Lấy dữ liệu thành công" });
        const data = res.data.data;
        const newData = {
          ...data,
          phanTramMienGiam: data.phanTramMienGiam * 100,
          ngayVaoVien: moment(data.ngayVaoVien, "DD/MM/YYYY", true),
          tenNhanVienThanhToan: localStorage.getItem("fullName"),
        };
        form.setFieldsValue(newData);
        setData(newData);
        setTrangThaiBH(res.data.data.idTrangThaiBaoHiem);
        disPath(setIdReceiptPrint(res.data.data.idTrangThaiBaoHiem));
        disPath(setIdPhieuKham(res?.data?.data.id));
        disPath(setMaBenhNhan(res?.data?.data.maBenhNhan));
        dispatchCurrentRoom(disPath, res?.status, TEN_PHONG.thanh_toan);
      });
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy dữ liệu chi tiết bệnh nhân"
      );
    }
  };

  // const onChangeInput = (event) => {
  //   let value = event.target.value;
  //   disPath(setValueInput(value));
  // };

  const handleOnPrint = () => {
    // console.log('trang thai bao hiem', trangThaiBH);

    if (trangThaiBH == 1 || trangThaiBH == null) {
      setIsShowModalPrintBH(true);
      setIsShowModalPrint(false);
      return;
    }
    if (trangThaiBH == 0) {
      setIsShowModalPrint(true);
      setIsShowModalPrintBH(false);
      return;
    }
  };
  const handleOnPrintPTT = () => {
    if (listIdPrint.length == 0 || !listIdPrint) {
      Notification("warning", "Vui lòng chọn dịch vụ đã thanh toán");
      return;
    }
    setIsShowModalPrintPTT(true);
  };

  const handleOnOpenPTT = () => {
    setIsShowModalPrintPTT(false);
  };

  const handleCancelPrintPTT = () => {
    setIsShowModalPrintPTT(false);
  };

  const handleOnPrintList = () => {
    setIsShowModalOption(true);
  };

  const handleOpen = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };

  const handleOpenOption = () => {
    setIsShowModalOption(false);
  };

  const handleCancelOption = () => {
    setIsShowModalOption(false);
  };

  const handleOpenBH = () => {
    setIsShowModalPrintBH(false);
  };

  const handleCancelPrintBH = () => {
    setIsShowModalPrintBH(false);
  };
  const isInPayTab = useAppSelector((e) => e.reduxCommon.isInPayTab);

  useEffect(() => {
    if (isInPayTab) {
      setIsShowModalOption(true);
    }
  }, [isInPayTab]);
  return (
    <div className="pay-tab-container">
      <Space direction="vertical" style={{ width: "100%" }}>
        <div className="container">
          <div className="patient-prescription-info">
            <Form form={form}>
              <Space direction="vertical">
                <PatientInfoCommon data={data} fields={field} />
                <Row
                  justify={"end"}
                  gutter={[16, 8]}
                  style={{ marginTop: "16px" }}
                >
                  <Col>
                    <Space>
                      <Button
                        className="btn-sub"
                        icon={<Icon.printer />}
                        onClick={handleOnPrintPTT}
                      >
                        In phiếu thu tiền
                      </Button>
                      <Button
                        className="btn-sub"
                        icon={<Icon.printer />}
                        onClick={handleOnPrintList}
                      >
                        In bảng kê nội trú
                      </Button>
                      <Button
                        className="btn-sub"
                        icon={<Icon.printer />}
                        onClick={handleOnPrint}
                      >
                        In phiếu thu tổng
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Space>
            </Form>
          </div>
        </div>
        {/* <div className="container step">
          <StepInfo ref={stepInfoRef} />
        </div> */}
        <PayDetailTab
          data={{ ...data }}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
      </Space>
      <ModalPrint
        isShowModal={isShowModalPrint}
        handleOk={handleOpen}
        handleCancel={handleCancelPrint}
      />
      <ModalPrintBH
        isShowModal={isShowModalPrintBH}
        handleOk={handleOpenBH}
        handleCancel={handleCancelPrintBH}
      ></ModalPrintBH>
      <ModalOption
        isShowModal={isShowModalOption}
        handleOk={handleOpenOption}
        handleCancel={handleCancelOption}
      />
      <ModalPrintPTT
        isShowModal={isShowModalPrintPTT}
        handleOk={handleOnOpenPTT}
        handleCancel={handleCancelPrintPTT}
      />
    </div>
  );
};

export default PayTab;
